import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, Lock } from 'lucide-react';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 24
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSecs = prev.seconds - 1;
        let newMins = prev.minutes;
        let newHours = prev.hours;
        if (newSecs < 0) {
          newSecs = 59;
          newMins -= 1;
        }
        if (newMins < 0) {
          newMins = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMins,
          seconds: newSecs
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-navy py-12 px-6 border-t border-white/10 relative overflow-hidden" data-id="element-89">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-90">
        <div className="text-center mb-8" data-id="element-91">
          <h3 className="text-gold font-bold text-xl mb-4 uppercase tracking-wider" data-id="element-92">
            ⏰ EL PRECIO CIERRA EN:
          </h3>
          <div className="flex justify-center items-center gap-3 md:gap-4 mb-8" data-id="element-93">
            <div className="flex flex-col items-center" data-id="element-94">
              <div className="bg-white/5 border border-gold/30 rounded-xl w-16 h-16 md:w-20 md:h-20 flex items-center justify-center shadow-[0_0_15px_rgba(201,168,76,0.15)] backdrop-blur-sm" data-id="element-95">
                <span className="font-display font-bold text-3xl md:text-4xl text-gold" data-id="element-96">
                  {format(timeLeft.hours)}
                </span>
              </div>
              <span className="text-[10px] md:text-xs text-gray-400 mt-2 uppercase tracking-widest font-semibold" data-id="element-97">
                Horas
              </span>
            </div>
            <div className="text-gold/50 font-bold text-2xl md:text-3xl pb-6 md:pb-7 animate-pulse" data-id="element-98">
              :
            </div>
            <div className="flex flex-col items-center" data-id="element-99">
              <div className="bg-white/5 border border-gold/30 rounded-xl w-16 h-16 md:w-20 md:h-20 flex items-center justify-center shadow-[0_0_15px_rgba(201,168,76,0.15)] backdrop-blur-sm" data-id="element-100">
                <span className="font-display font-bold text-3xl md:text-4xl text-gold" data-id="element-101">
                  {format(timeLeft.minutes)}
                </span>
              </div>
              <span className="text-[10px] md:text-xs text-gray-400 mt-2 uppercase tracking-widest font-semibold" data-id="element-102">
                Minutos
              </span>
            </div>
            <div className="text-gold/50 font-bold text-2xl md:text-3xl pb-6 md:pb-7 animate-pulse" data-id="element-103">
              :
            </div>
            <div className="flex flex-col items-center" data-id="element-104">
              <div className="bg-white/5 border border-danger/30 rounded-xl w-16 h-16 md:w-20 md:h-20 flex items-center justify-center shadow-[0_0_15px_rgba(239,68,68,0.15)] backdrop-blur-sm" data-id="element-105">
                <span className="font-display font-bold text-3xl md:text-4xl text-danger" data-id="element-106">
                  {format(timeLeft.seconds)}
                </span>
              </div>
              <span className="text-[10px] md:text-xs text-gray-400 mt-2 uppercase tracking-widest font-semibold" data-id="element-107">
                Segundos
              </span>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-8" data-id="element-108">
          {/* Compact Option 1 */}
          <div className="bg-white rounded-2xl p-5 text-center border border-gray-200" data-id="element-109">
            <span className="text-sm font-bold mb-1 block text-[#060E1A]" data-id="element-110">
              🔘 OPCIÓN 1
            </span>
            <h4 className="font-display text-xl font-bold text-primary mb-1" data-id="element-111">
              📘 MEGAPACK 1
            </h4>
            <p className="text-sm mb-3 text-[#1A1A1A]" data-id="element-112">
              5 Tomos + 3 Bonos · Empezar desde hoy
            </p>
            <div className="mb-4" data-id="element-113">
              <span className="text-gray-400 line-through text-lg mr-2" data-id="element-114">
                75,76€
              </span>
              <span className="text-3xl font-extrabold text-primary" data-id="element-115">
                14,97€
              </span>
            </div>
            <button onClick={scrollToPricing} className="w-full bg-gray-900 text-white font-bold py-2.5 rounded-xl hover:bg-gray-800 transition-colors" data-id="element-116">
              → QUIERO MI MEGAPACK
            </button>
          </div>

          {/* Compact Option 2 */}
          <div className="bg-gold/10 rounded-2xl p-5 text-center border-2 border-gold relative" data-id="element-117">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-navy text-xs font-bold px-3 py-1 rounded-full" data-id="element-118">
              ⭐ MÁS ELEGIDO
            </div>
            <span className="text-sm font-bold text-gold mb-1 block mt-1" data-id="element-119">
              🔘 OPCIÓN 2
            </span>
            <h4 className="font-display text-xl font-bold text-white mb-1" data-id="element-120">
              🏆 MEGAPACK COMPLETO
            </h4>
            <p className="text-sm text-gray-300 mb-3" data-id="element-121">
              10 Tomos + 7 Bonos · Sistema Completo
            </p>
            <div className="mb-4" data-id="element-122">
              <span className="text-gray-400 line-through text-lg mr-2" data-id="element-123">
                157,49€
              </span>
              <span className="text-3xl font-extrabold text-gold" data-id="element-124">23,97€</span>
            </div>
            <button onClick={scrollToPricing} className="w-full bg-gold text-navy font-extrabold py-2.5 rounded-xl hover:bg-gold-light transition-colors shadow-[0_0_15px_rgba(201,168,76,0.3)]" data-id="element-125">
              → QUIERO EL SISTEMA COMPLETO
            </button>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-400 font-medium" data-id="element-126">
          <span className="flex items-center gap-2" data-id="element-127">
            <Lock className="w-4 h-4" data-id="element-128" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-129">
            <Zap className="w-4 h-4" data-id="element-130" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-131">
            <ShieldCheck className="w-4 h-4" data-id="element-132" /> Garantía 7 días
          </span>
        </div>
      </div>

      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full overflow-hidden pointer-events-none opacity-10" data-id="element-133">
        <div className="absolute bottom-[-50%] left-1/2 -translate-x-1/2 w-[100%] h-[100%] rounded-full bg-gold blur-[150px]" data-id="element-134"></div>
      </div>
    </section>;
}